import * as angular from 'angular';
import * as _ from 'lodash';

import { Alias, VariableType, VariableSubType, AliasBinding, ComponentDefinition, VariableTableViewModel } from '../../../models';
import { IVariableService, IAliasService } from '../../../services';
import { mapForTable } from './mappers';

class VariablesStateController implements angular.IComponentController {
    viewModels: VariableTableViewModel[];
    inputs: {
        bindings: AliasBinding[];
        customAliases: Alias[];
        defaultAliases: Alias[];
        subTypes: VariableSubType[];
        variables: VariableType[];
    };
    isLoading: boolean;
    loadingMessage: string;
    isEditMode: boolean;

    static $inject = ['$q', 'variableService', 'aliasService'];

    constructor(private _$q: angular.IQService,
        private _variableService: IVariableService,
        private _aliasService: IAliasService) {
    }

    $onInit() {
        this.isLoading = true;
        this._$q.all([
            this._variableService.getAll(),
            this._aliasService.getDefault(),
            this._aliasService.getCustom(),
            this._variableService.getAllSubtypes(),
            this._aliasService.getBindings()
        ]).then(responses => {
            const variables = responses[0].map(d => d.variable);
            const defaultAliases = responses[1];
            const customAliases = responses[2];
            const subTypes = responses[3];
            const bindings = responses[4];
            this.inputs = {
                variables,
                defaultAliases,
                customAliases,
                subTypes,
                bindings
            };
            this.viewModels = mapForTable(variables, defaultAliases, customAliases, subTypes, bindings);
        }).finally(() => this.isLoading = false);
    }

    editTable() {
        this.isEditMode = true;
    }

    save() {
        this.isEditMode = false;
    }

    cancel() {
        this.isEditMode = false;
    }
}

export const wtVariablesState: ComponentDefinition = {
    componentId: 'wtVariablesState',
    controller: VariablesStateController,
    template: require('./variablesState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
